<div
  class="edit-pair-dialog-container"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <form class="edit-pair-pair-dialog-form" [formGroup]="_form" (ngSubmit)="edit()">
    <!-- ! Delete Message -->
    <div *ngIf="_deletedField">
      <div class="alert alert-success success-msg">
        <div>
          <ng-lottie width="30px" [options]="options"></ng-lottie>
        </div>
        <div *ngIf="_deleteFromDDC">
          &nbsp;&nbsp;&nbsp;Pair "{{ _editedField1 }}={{ _editedField2 }}" has been deleted.
        </div>
        <div *ngIf="_deleteFromDic">
          &nbsp;&nbsp;&nbsp;Pair "{{ _editedField1 }}={{ _editedField2 }}" has been removed from dictionary.
        </div>
      </div>
    </div>
    <!-- ! Title -->
    <div *ngIf="!_deletedField">
      <ddc-text-gradient
        class="text-2xl"
        [_icon]="'fiber_smart_record'"
        [_text]="'Pair'"
        [_type]="'1'"
      ></ddc-text-gradient>
      <mat-divider style="margin-bottom: 10px; margin-top: 10px"></mat-divider>
    </div>
    <!-- ! Success Message -->
    @if (_isPairEdited) {
      <div class="alert alert-success success-msg">
        <div>
          <ng-lottie width="30px" [options]="options"></ng-lottie>
        </div>
        <div>&nbsp;&nbsp;&nbsp;Pair "{{ _editedField1 }}={{ _editedField2 }}" has been edited.</div>
      </div>
    }
    <!-- ! Both words -->
    @else if (!_deletedField && !_isPairEdited) {
      <div class="add-dialog-both-container">
        <!-- * First Container -->
        <div class="add-dialog-first-container first-container-border">
          <!-- ! Error -->
          <div class="alert alert-danger" *ngIf="_editError">
            {{ _editError }}
          </div>
          <!-- ! Label 1 -->
          <ddc-text-gradient class="text-2xl" [_text]="'From'" [_type]="'1'"></ddc-text-gradient>
          <!-- ! Language 1-->
          <div class="add-dialog-row-1 add-dialog-lng">
            <mat-form-field>
              <mat-label><mat-icon>language</mat-icon>&nbsp;&nbsp;Language</mat-label>
              <mat-select formControlName="_1_language" (selectionChange)="onLanguageChange($event)">
                <mat-option *ngFor="let language of languages" [value]="language.raw_value">
                  {{ language.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- ! Article, Word, Pos 1-->
          <div class="add-dialog-row-2">
            <!-- Article 1-->
            <mat-form-field class="add-dialog-article">
              <mat-label>Article</mat-label>
              <mat-select formControlName="_1_article" name="article1">
                <mat-option
                  *ngFor="let article of articles"
                  [ngStyle]="{ 'background-color': article.view_value === 'None' ? 'rgb(231, 189, 189)' : '' }"
                  [value]="article.raw_value"
                >
                  {{ article.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <!--  Word 1 -->
            <mat-form-field class="add-dialog-word">
              <mat-label>Word</mat-label>
              <input formControlName="_1_word" matInput placeholder="Ex. Apple" />
              <!-- * Errors -->
              <mat-error *ngIf="w1.hasError('maxlength')">
                Maximum <strong>{{ _wordMaxlength }}</strong> characters.
              </mat-error>
              <mat-error *ngIf="w1.hasError('required')"> Required. </mat-error>
            </mat-form-field>
            <!-- Pos 1 -->
            <mat-form-field class="add-dialog-pos">
              <mat-label>Pos</mat-label>
              <mat-select formControlName="_1_pos">
                <mat-option
                  *ngFor="let pos of poses"
                  [ngStyle]="{ 'background-color': pos.view_value === 'None' ? 'rgb(231, 189, 189)' : '' }"
                  [value]="pos.raw_value"
                >
                  {{ pos.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- ! Definition 1-->
          <div class="add-dialog-row-3">
            <mat-form-field class="add-dialog-definition">
              <mat-label>Definition</mat-label>
              <textarea
                formControlName="_1_definition"
                matInput
                placeholder="Ex. The round fruit of a tree of the rose family"
              ></textarea>
              <!-- * Errors -->
              <mat-error *ngIf="def1.hasError('maxlength')">
                Maximum <strong>{{ _definitionMaxlength }}</strong> characters.
              </mat-error>
            </mat-form-field>
          </div>
          <!-- ! Example 1-->
          <div class="add-dialog-row-4">
            <mat-form-field class="add-dialog-example">
              <mat-label>Example</mat-label>
              <textarea formControlName="_1_example" matInput placeholder="Ex. I ate an apple"></textarea>
              <!-- * Errors -->
              <mat-error *ngIf="exp1.hasError('maxlength')">
                Maximum <strong>{{ _exampleMaxlength }}</strong> characters.
              </mat-error>
            </mat-form-field>
          </div>
          <!-- ! Category 1-->
          <div class="add-dialog-cat">
            <ddc-elem-chooser-one
              *ngIf="_loadedCats"
              [_allElems]="_userCats"
              [_defaultElem]="_element.word_1.category"
              [_elemType]="'category'"
              [_label]="'Category'"
              [_labelIcon]="'workspaces'"
              [_placeholder]="'Select a Category'"
              [_type]="'single'"
              (selectedElemsChange)="updateSelectedCat($event)"
            ></ddc-elem-chooser-one>
          </div>
          <!-- ! Tags1 -->
          <ddc-elem-chooser-one
            *ngIf="_loadedTags"
            [_allElems]="_userTags"
            [_defaultElems]="_element.word_1.tags"
            [_elemType]="'tag'"
            [_label]="'Tags'"
            [_labelIcon]="'sell'"
            [_placeholder]="'Select tags...'"
            [_type]="'multi'"
            (selectedElemsChange)="updateSelectedTags($event)"
          ></ddc-elem-chooser-one>
          <!-- ! Privacy 1 -->
          <mat-chip-listbox
            *ngIf="!_deletedField"
            aria-label="privacy selection"
            formControlName="_1_privacy"
            [ngClass]="{
              'dark-theme': _isDarkTheme,
              'light-theme': _isLightTheme,
              'paper-theme': _isPaperTheme,
            }"
          >
            <mat-chip-option selected [value]="'P01'"><mat-icon matChipAvatar>public</mat-icon>Public</mat-chip-option>
            <mat-chip-option [value]="'P02'"><mat-icon matChipAvatar>group</mat-icon>Followers</mat-chip-option>
            <mat-chip-option [value]="'P03'"><mat-icon matChipAvatar>lock</mat-icon>Only Me</mat-chip-option>
          </mat-chip-listbox>
        </div>
        <!-- * Second Container -->
        <div class="add-dialog-container second-container-border" *ngIf="!_deletedField">
          <!-- ! Error -->
          <div class="alert alert-danger" *ngIf="_editError">
            {{ _editError }}
          </div>
          <!-- ! Success Message -->
          <!-- <div *ngIf="_editedField2">
                      <div class="alert alert-success success-msg">
                          <div>
                              <ng-lottie
                                  width="30px"
                                  [options]="options"
                              ></ng-lottie>
                          </div>
                          <div>&nbsp;&nbsp;&nbsp;Word "{{_editedField2}}" has been edited.</div>
                      </div>
                  </div> -->
          <!-- ! Label 2 -->
          <ddc-text-gradient class="text-2xl" [_text]="'To'" [_type]="'1'"></ddc-text-gradient>
          <!-- ! Language 2-->
          <div class="add-dialog-row-1 add-dialog-lng">
            <mat-form-field>
              <mat-label><mat-icon>language</mat-icon>&nbsp;&nbsp;Language</mat-label>
              <mat-select formControlName="_2_language" (selectionChange)="onLanguageChange2($event)">
                <mat-option *ngFor="let language of languages" [value]="language.raw_value">
                  {{ language.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- ! Article, Word, Pos 2-->
          <div class="add-dialog-row-2">
            <!-- Article 2-->
            <mat-form-field class="add-dialog-article">
              <mat-label>Article</mat-label>
              <mat-select formControlName="_2_article" name="article2">
                <mat-option
                  *ngFor="let article of articles2"
                  [ngStyle]="{ 'background-color': article.view_value === 'None' ? 'rgb(231, 189, 189)' : '' }"
                  [value]="article.raw_value"
                >
                  {{ article.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <!--  Word 2 -->
            <mat-form-field class="add-dialog-word">
              <mat-label>Word</mat-label>
              <input formControlName="_2_word" matInput placeholder="Ex. Apple" />
              <!-- * Errors -->
              <mat-error *ngIf="w1.hasError('maxlength')">
                Maximum <strong>{{ _wordMaxlength }}</strong> characters.
              </mat-error>
              <mat-error *ngIf="w1.hasError('required')"> Required. </mat-error>
            </mat-form-field>
            <!-- Pos 2 -->
            <mat-form-field class="add-dialog-pos">
              <mat-label>Pos</mat-label>
              <mat-select formControlName="_2_pos">
                <mat-option
                  *ngFor="let pos of poses"
                  [ngStyle]="{ 'background-color': pos.view_value === 'None' ? 'rgb(231, 189, 189)' : '' }"
                  [value]="pos.raw_value"
                >
                  {{ pos.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- ! Definition 2-->
          <div class="add-dialog-row-3">
            <mat-form-field class="add-dialog-definition">
              <mat-label>Definition</mat-label>
              <textarea
                formControlName="_2_definition"
                matInput
                placeholder="Ex. The round fruit of a tree of the rose family"
              ></textarea>
              <!-- * Errors -->
              <mat-error *ngIf="def1.hasError('maxlength')">
                Maximum <strong>{{ _definitionMaxlength }}</strong> characters.
              </mat-error>
            </mat-form-field>
          </div>
          <!-- ! Example 2-->
          <div class="add-dialog-row-4">
            <mat-form-field class="add-dialog-example">
              <mat-label>Example</mat-label>
              <textarea formControlName="_2_example" matInput placeholder="Ex. I ate an apple"></textarea>
              <!-- * Errors -->
              <mat-error *ngIf="exp1.hasError('maxlength')">
                Maximum <strong>{{ _exampleMaxlength }}</strong> characters.
              </mat-error>
            </mat-form-field>
          </div>
          <!-- ! Category 2-->
          <div class="add-dialog-cat">
            <ddc-elem-chooser-one
              *ngIf="_loadedCats"
              [_allElems]="_userCats"
              [_defaultElem]="_element.word_2.category"
              [_elemType]="'category'"
              [_label]="'Category'"
              [_labelIcon]="'workspaces'"
              [_placeholder]="'Select a Category'"
              [_type]="'single'"
              (selectedElemsChange)="updateSelectedCat2($event)"
            ></ddc-elem-chooser-one>
          </div>
          <!-- ! Tags 2 -->
          <ddc-elem-chooser-one
            *ngIf="_loadedTags"
            [_allElems]="_userTags"
            [_defaultElems]="_element.word_2.tags"
            [_elemType]="'tag'"
            [_label]="'Tags'"
            [_labelIcon]="'sell'"
            [_placeholder]="'Select tags...'"
            [_type]="'multi'"
            (selectedElemsChange)="updateSelectedTags2($event)"
          ></ddc-elem-chooser-one>
          <!-- ! Privacy 2 -->
          <mat-chip-listbox
            *ngIf="!_deletedField"
            aria-label="privacy selection"
            formControlName="_2_privacy"
            [ngClass]="{
              'dark-theme': _isDarkTheme,
              'light-theme': _isLightTheme,
              'paper-theme': _isPaperTheme,
            }"
          >
            <mat-chip-option selected [value]="'P01'"><mat-icon matChipAvatar>public</mat-icon>Public</mat-chip-option>
            <mat-chip-option [value]="'P02'"><mat-icon matChipAvatar>group</mat-icon>Followers</mat-chip-option>
            <mat-chip-option [value]="'P03'"><mat-icon matChipAvatar>lock</mat-icon>Only Me</mat-chip-option>
          </mat-chip-listbox>
        </div>
      </div>
      <!-- ! Dictionary 1 -->
      <ddc-elem-chooser-one
        *ngIf="_loadedDics && !_deletedField && !_isPairEdited"
        [_allElems]="_userDics"
        [_defaultElems]="_element.dictionaries"
        [_elemType]="'dictionary'"
        [_label]="'Dictionaries'"
        [_labelIcon]="'book'"
        [_placeholder]="'Add to dictionaries...'"
        [_type]="'multi'"
        (selectedElemsChange)="updateSelectedDics($event)"
      ></ddc-elem-chooser-one>

      <mat-divider style="margin-bottom: 10px; margin-top: 20px"></mat-divider>
    }
    <!-- ! Footer -->
    <div class="edit-word-dialog-submit-container">
      <div class="edit-word-dialog-submit-container-right" *ngIf="!_deletedField && !_isPairEdited">
        <!-- Delete -->
        <button
          class="edit-word-dialog-delete-btn"
          color="accent"
          mat-flat-button
          type="button"
          (click)="openDeleteDialog()"
        >
          <mat-icon>delete</mat-icon>Delete
        </button>
        <!-- Edit -->
        <ddc-button-s-one
          class="ddc-submit-btn"
          [_isLoading]="_isEditBtnLoading"
          [_label]="_submitBtnText"
          (buttonClick)="edit()"
        ></ddc-button-s-one>
      </div>
      <div class="edit-word-dialog-submit-container-left">
        <!-- Cancel -->
        <button class="edit-word-dialog-close-btn" mat-button type="button" (click)="closeDialog()">Cancel</button>
      </div>
    </div>
  </form>
</div>
